import { render, staticRenderFns } from "./Wai.vue?vue&type=template&id=1bdc3d74&scoped=true&lang=pug&"
import script from "./Wai.vue?vue&type=script&lang=ts&"
export * from "./Wai.vue?vue&type=script&lang=ts&"
import style0 from "./Wai.vue?vue&type=style&index=0&id=1bdc3d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc3d74",
  null
  
)

export default component.exports